// import {PWMAT_RESOURCE} from './consts'

export const Seminar = [{
  name:'第一期',
  url:'https://www.bilibili.com/video/BV1zd4y1A7GC/?spm_id_from=333.999.0.0',
  file_name:'纳米结构大体系材料计算'
},
{
  name:'第二期',
  url:'https://www.bilibili.com/video/BV1zd4y1A7GC?p=2',
  file_name:'用固定电势法发表高影响力论文'
},
{
  name:'第三期',
  url:'https://www.bilibili.com/video/BV1zd4y1A7GC?p=3',
  file_name:'用rt-TDDFT发表高影响力论文'
},
]
